import { appendElement, appendElementIf } from '../xml-helpers';

/**
 * Builds an `<institution>` element with an optional `<institution_name>`
 * and an optional `<institution_id>` of type ROR.
 */
export function buildInstitution(
  parent: Element,
  name?: string,
  rorId?: string
): Element {
  const inst = appendElement(parent, 'institution');
  appendElementIf(inst, 'institution_name', name);
  appendElementIf(inst, 'institution_id', rorId, { type: 'ror' });
  return inst;
}
